import { IEntityTerminationTask } from '../../components/entityTermination/types';

/**
 * Maps the form owner field to the API input shape.
 * Handles both single-item arrays (from PeoplePicker) and direct objects.
 */
export const buildOwnerInput = (formData: IEntityTerminationTask) => {
  const ownerData = Array.isArray(formData.owner) ? formData.owner[0] : formData.owner;
  return ownerData
    ? {
        id: ownerData.id,
        graphId: ownerData.graphId,
        name: ownerData.name,
        firstName: ownerData.firstName,
        lastName: ownerData.lastName,
        email: ownerData.email,
        alias: ownerData.alias,
      }
    : null;
};

/**
 * Maps the form assignees field to the API input shape.
 */
export const buildAssigneesInput = (formData: IEntityTerminationTask) =>
  (Array.isArray(formData.assignees) ? formData.assignees : []).map((a) => ({
    id: a.id,
    graphId: a.graphId,
    name: a.name,
    firstName: a.firstName,
    lastName: a.lastName,
    email: a.email,
    alias: a.alias,
  }));
